export default "__VITE_ASSET__BiqCWjwI__"